
import { defineComponent } from "vue";
import { AxiosError } from "axios";

import { useAuthStore } from "@/stores/authStore";
import { useConfigStore } from "@/stores/configStore";
import { useSiteStore } from "@/stores/siteStore";
import { useSupportRequestStore } from "@/stores/supportRequestStore";

export default defineComponent({
	name: "imdex-support-request",
	setup() {
		return {
			authStore: useAuthStore(),
			configStore: useConfigStore(),
			siteStore: useSiteStore(),
			supportRequestStore: useSupportRequestStore()
		};
	},
	data() {
		return {
			submittingSupportRequest: false,
			submitError: false,
			submitErrorMessage: "",
			request: {
				name: "",
				email: "",
				company: "",
				tenant: "",
				site: "",
				subject: "",
				message: ""
			}
		};
	},
	async mounted() {
		await this.configStore.init();
		this.request = {
			name: this.currentUser?.name,
			email: this.currentUser?.email,
			company: this.supportConfig.company,
			tenant: this.supportConfig.tenant,
			site: this.isUserLoggedIn ? this.activeSite?.name ?? "" : "Not logged in",
			subject: "",
			message: ""
		};
		this.$nextTick(() => {
			if (this.isUserLoggedIn) {
				(this.$refs as any).subject.focusInput();
			} else {
				(this.$refs as any).name.focusInput();
			}
		});
	},
	computed: {
		isUserLoggedIn(): boolean {
			return !!this.authStore.user && !!this.authStore.user.name;
		},
		currentUser(): any {
			return this.authStore.user ?? { name: "", email: "" };
		},
		supportConfig(): any {
			return this.configStore.config?.support ?? { company: "", tenant: "" };
		},
		activeSite(): any {
			return this.siteStore.activeSite;
		},
		readonly(): any {
			return {
				name: this.$data.request.name.trim() !== "",
				email: this.$data.request.email.trim() !== "",
				company: this.$data.request.company.trim() !== "",
				tenant: this.$data.request.tenant.trim() !== "",
				site: this.$data.request.site.trim() !== ""
			};
		}
	},
	methods: {
		close() {
			this.supportRequestStore.close();
			this.$emit("close");
		},
		async submitSupportRequest() {
			this.submittingSupportRequest = true;
			this.submitError = false;
			this.submitErrorMessage = "";

			Object.keys(this.request).forEach((key) => {
				if (this.submitError) return;

				const value = this.$data.request[key as keyof typeof this.$data.request];

				if (!value || (value && !value.trim())) {
					this.submitError = true;
					this.submitErrorMessage = this.$t(`supportRequest.submitError`);
					this.submittingSupportRequest = false;
					return;
				}
			});

			if (this.submitError) return;

			this.supportRequestStore
				.submit(this.$data.request)
				.then(() => {
					this.$emit("close");
				})
				.catch((e) => {
					this.submittingSupportRequest = false;
					this.submitError = true;
					if (e instanceof AxiosError) {
						if (e.response != null)
							this.submitErrorMessage = e.response.data.message || e.response.data;
					} else {
						this.submitErrorMessage = this.$t(`supportRequest.submitErrorGeneral`);
					}
				});
		}
	}
});
